import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from './initialState'
import { NestedFilterObject } from '@/core/hooks/useFiltersInBody.ts'

const serviceRechargeInvoicesSlice = createSlice({
  name: 'serviceRechargeInvoices',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<NestedFilterObject>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const serviceRechargeInvoicesActions =
  serviceRechargeInvoicesSlice.actions
export const { reducer: serviceRechargeInvoicesReducer } =
  serviceRechargeInvoicesSlice
